import { Component, OnDestroy, OnInit } from '@angular/core';
import { CustomizationFacade } from '../../../store/customization/customization.facade';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { valueSelectedValidator } from '../../../directives/validators/value-selected.directive';
import { confirmPasswordValidator } from '../../../directives/validators/confirm-password.directive';
import { AuthenticationFacadeService } from '../../../services/authentication/authentication-facade.service';
import { UserSignUp } from '../../../models/authentication/user-sign-up.model';
import { BehaviorSubject, catchError, EMPTY, Subscription, take, tap } from 'rxjs';
import { HttpErrorResponse } from '@angular/common/http';

@Component({
    selector: 'app-sign-up',
    templateUrl: './sign-up.component.html',
    styleUrl: './sign-up.component.scss'
})
export class SignUpComponent implements OnInit, OnDestroy {
    customizations$ = this.customizationFacade.customization$;
    signUpForm: FormGroup = new FormGroup({});

    signUpStatus$: BehaviorSubject<string | null> = new BehaviorSubject<string | null>(null);
    signUpAction$: Subscription = new Subscription();

    constructor(
        private customizationFacade: CustomizationFacade,
        private authenticationFacadeService: AuthenticationFacadeService
    ) {}

    ngOnInit() {
        this.signUpForm = new FormGroup(
            {
                gender: new FormControl<string>('', [Validators.required, valueSelectedValidator()]),
                userName: new FormControl<string>('', Validators.required),
                firstName: new FormControl<string>('', Validators.required),
                lastName: new FormControl<string>('', Validators.required),
                email: new FormControl<string>('', [Validators.required, Validators.email]),
                password: new FormControl<string>('', Validators.required),
                passwordConfirm: new FormControl<string>(''),
                isAgbAccepted: new FormControl<boolean>(false)
            },
            {
                validators: [confirmPasswordValidator]
            }
        );
    }

    signUp() {
        if (this.signUpForm.valid) {
            this.signUpAction$ = this.authenticationFacadeService
                .signUp(this.signUpForm.value as UserSignUp)
                .pipe(
                    tap(() => {
                        this.signUpStatus$.next('ok');
                    }),
                    catchError((error: HttpErrorResponse) => {
                        this.signUpStatus$.next(error.message);
                        return EMPTY;
                    }),
                    take(1)
                )
                .subscribe();
        } else {
            this.signUpForm.markAllAsTouched();
        }
    }

    // getter
    get gender() {
        return this.signUpForm.get('gender');
    }

    get userName() {
        return this.signUpForm.get('userName');
    }

    get firstName() {
        return this.signUpForm.get('firstName');
    }

    get lastName() {
        return this.signUpForm.get('lastName');
    }

    get email() {
        return this.signUpForm.get('email');
    }

    get password() {
        return this.signUpForm.get('password');
    }

    get passwordConfirm() {
        return this.signUpForm.get('passwordConfirm');
    }

    get isAgbAccepted() {
        return this.signUpForm.get('isAgbAccepted');
    }

    ngOnDestroy() {
        this.signUpAction$.unsubscribe();
    }
}
